import axios from '../request/http';

const Login = {
    // 获取验证码
    getCode() {
        return axios.get("/hemei-admin/login/captcha");
    },
    // 登录
    login(params) {
        return axios.get("/hemei-admin/login/login", { params });
    },
    // 获取角色列表
    adminJurisdiction(params) {
        return axios.get("/hemei-admin/role/getRoleList", { params });
    },
    // 获取账号基本信息
    getInfo(params) {
        return axios.get("/hemei-admin/admin/getInfo", { params });
    },
    // 获取临时 token
    get_sts_token(params) {
        return axios.get("/hemei-admin/base/oss/get_sts_token", { params });
    },

}

export default Login;


// WEBPACK FOOTER //
// ./src/api/Login.js